import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listProviders: [],
};

const serviceProviderSlice = createSlice({
  name: "serviceProvider",
  initialState,
  reducers: {
    setAllServicesProviders: (state, action) => {
      state.listProviders = action.payload.listProviders;
    },
    clearServicesProviders: (state) => {
      state.listProviders = [];
    },
  },
});

export const { setAllServicesProviders, clearServicesProviders } =
  serviceProviderSlice.actions;

export default serviceProviderSlice.reducer;
